<template>
  <div class="section crossed-bottom">
    <b-container class="timeline-container">
     <div class="title-wrapper">
        <span>
          <h2 class="font-bad font-weight-bold text-center mb-0"> Carreer </h2>
        </span>
      </div>
      <b-progress class="mt-2 progress-wicon" :max="max" show-value>
        <b-progress-bar 
          :value="sectionValues[0]"  
          :class="['timeline-item', sectionClasses[0]]">
          <a class="timeline-link" @click="changeProgress(0)">
            <i class="fas fa-graduation-cap"></i>
          </a>
        </b-progress-bar>
        <b-progress-bar 
          :value="sectionValues[1]" 
          :class="['timeline-item', sectionClasses[1]]"
          class="timeline-item">
            <a class="timeline-link" @click="changeProgress(1)">
              <i class="fab fa-searchengin"></i>
            </a>
        </b-progress-bar>
        <b-progress-bar 
          :value="sectionValues[2]" 
          :class="['timeline-item', sectionClasses[2]]">
          <a class="timeline-link" @click="changeProgress(2)">
            <i class="fas fa-plane-departure"></i>
          </a>
        </b-progress-bar>
        <b-progress-bar 
          :value="sectionValues[3]" 
          :class="['timeline-item', sectionClasses[3]]">
          <a class="timeline-link" @click="changeProgress(3)">
            <i class="fas fa-globe"></i>
          </a>
        </b-progress-bar>
        <b-progress-bar 
          :value="sectionValues[4]" 
          :class="['timeline-item', sectionClasses[4]]">
          <a class="timeline-link" @click="changeProgress(4)">
            <i class="fas fa-chalkboard-teacher"></i>
          </a>
        </b-progress-bar>
        <b-progress-bar 
          :value="sectionValues[5]" 
          :class="['timeline-item', sectionClasses[5]]">
          <a class="timeline-link" @click="changeProgress(5)">
            <i class="fab fa-vuejs"></i>
          </a>
        </b-progress-bar>
      </b-progress>
      <div class="timeline-slider mt-5">
        <div class="timeline-slider__content d-flex">
          <div class="chevron left">
            <a @click="prevSlide" class="justify-content-start">
              <i class="fas fa-chevron-left color-pink-accent"></i>
            </a>
          </div>
          <div class="current-slide-area">
            <div 
              v-for="slide in carreerItems"
              v-bind:key="slide.id">
              <transition name="fade-slide">
                <div 
                  class="timeline-slide" 
                  id="slide-0" 
                  v-if="currentSlide == slide.id">
                  <h3 class="carreer-title color-gray-dark mb-3"> 
                    {{slide.title}}
                  </h3>
                  <p class="carrer-place mb-1"> 
                    {{slide.place}} 
                  </p>
                  <small>{{slide.time}}</small> 
                  <p class="carrer-description mt-4"
                    v-html="slide.description">
                   
                  </p>
                </div>
              </transition>
            </div>
           
          </div>
          <div class="chevron right">
            <a @click="nextSlide" class="justify-content-end">
              <i class="fas fa-chevron-left color-pink-accent"></i>
            </a>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    data() {
      return {
        max: 100,
        totalItems: 6,
        filledValue: (100/6),
        //sectionValues: [(100/7), 0, 0]
        sectionValues: [(100/6), (100/6), (100/6), (100/6), (100/6), (100/6)],
        sectionClasses: ['active', '', '', '', '', ''],
        currentSlide: 0,
        carreerItems: [
          {
            id: '0',
            title: 'Telematic Engineering',
            place: 'Universidad del Caribe',
            time: '2009 - 2014',
            description: `<ul class="text-left">
              <li> Area: Service networks </li>
              <li> Graduation Project: Design and development of system for evaluation of operative program for full time professors. </li>
              <li> Exhibition of graduation project at the ANIEI National Congress (Toluca, 2013). </li>
              </ul>`,
          },
          {
            id: '1',
            title: 'Research assistant',
            place: 'CONACYT, Universidad del Caribe',
            time: '2012',
             description: `<ul class="text-left">
              <li> Assistant in development of GUI Interface in MATLAB for obtaining and managing information on proteins and their cavities.</li>
              <li> Project development included a scholarship </li>
              </ul>`,
          },
          {
            id: '2',
            title: 'Software Developer',
            place: 'PriceTravel Holding',
            time: '2013 - 2016',
            description: `<ul class="text-left">
              <li> Fix reported bugs </li>
              <li> Implement new features for existing systems</li>
              <li> Automation of agencies/affiliates reports: sales, payments, commissions</li>
              <li> Development of Test automation platform with Selenium. </li>
              <li> <b> Main Achievement: </b> <br> TravelInn (B2B)Agencies Development (full stack .NET): A system to allow partner agencies to offer services to final user with different payment/commission schemes. Includes Commission system development.</li>
              </ul>`
          },
          {
            id: '3',
            title: 'Lead Software Developer',
            place: 'Vitzo LTD',
            time: '2016 - 2020',
            description: `<ul class="text-left">
              <li> Develop new browser extensions and implement new features for own brand extensions </li>
              <li> Help with recruitment process: search for candidates, interview them. </li>
              <li> Lead development of new website/tool (Vue and Node). 
              Project management (Scrum using JIRA). 20% Management, 80% Development.
              </li>
              <li> <b> Main Achievement: </b> Full stack development of a new own brand video website. Responsible of website positioning and SEO good practices, reaching more than 60 thousand daily sessions. </li>
            </ul>`
          },
          {
            id: '4',
            title: 'Instructor',
            place: 'LinkedIn Learning (Español)',
            time: '2017 - today',
            description: `
              <ul class="text-left">
                <li> Content creation and recording courses related to Software Development for LinkedIn Learning Platform.</li>
                
                <li> Main technologies: C#, .NET </li>
              </ul>
            `
          },
          {
            id: '5',
            title: 'Lead Software Developer',
            place: 'Diplus',
            time: '2020 - today',
            description: `<ul class="text-left">
              <li> Lead development of new platforms (using Vue.js and .NET).
              <li> Project Management (Scrum using JIRA). 20% Management, 80% Frontend Development.
              </li>
              <li> Mentoring backend Team using C# and .NET technologies </li>
              <li> <b> Main Achievement: </b> Development of Diplus website using Vue.js. SEO and performance best practices.</li>
            </ul>`
          }
        ]
      }
    },
    methods:{
      currentValue(item){
        return this.sectionValue * item;
      },
      changeProgress(selectedItem){
        console.log('changeProgress toggled', selectedItem);
        this.currentSlide = selectedItem;
        for (let i = 0; i <= this.totalItems-1; i++) {
          if(i<=selectedItem)
            Vue.set(this.sectionClasses, i, 'active');
          else
            Vue.set(this.sectionClasses, i, '');
        }
      },
      prevSlide(){
        if(this.currentSlide > 0){
          var prevS = this.currentSlide-1; 
          this.changeProgress(prevS);
        }
      },
      nextSlide(){
        if(this.currentSlide < this.totalItems-1){
          var nextS = this.currentSlide+1; 
          this.changeProgress(nextS);
        }
          
      }
    }
  }
</script>

<style>
.progress-wicon{
  height: 40px;
  border-radius: 0;
}
.timeline-container{
  margin-bottom: 50px;
}
.timeline-item i{
  font-size: 1.5rem;
  pointer-events: none;
}
.timeline-link{
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeline-item{
  background-color: #2C2B30;
  transition: background-color 1s ease;
}
.timeline-item.active{
  background-color: #F58F7C;
}
.timeline-slider__content .chevron{
  width: 10%;
  font-size: 50px;
}
.timeline-slider__content .chevron>a{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
.timeline-slider__content .chevron.right i{
  transform: rotate(180deg);
}
.timeline-slider__content .current-slide-area{
  width: 80%;
}
.fade-slide-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-slide-enter, .fade-slide-leave-to{
  opacity: 0;
  height: 0;
}
.chevron{
  cursor: pointer;
}
.current-slide-area ul li{
  list-style: none;
  margin-bottom: 0.5rem;
}
.current-slide-area ul li::before {
  content: "\00BB"; 
  color: #F58F7C;
  font-weight: normal;
  display: inline-block; 
  width: 1em;
  margin-left: -1em;
}

@media (min-width: 768px){
  .chevron i {
  opacity: 0;
  }
  .chevron:hover i {
    opacity: 1;
    transition: opacity 1s ease;
  }
}
</style>